/**
 * Active chef kitchen context. Set once by a chef-scoped layout/page (the
 * orders/kitchen page picks one kitchen from `useMyKitchensQuery`); read
 * by every chef component that needs to scope its data queries to "this
 * chef's kitchen" — substitution modal, resolution banner,
 * IngredientSubstitutionDisplay, etc.
 *
 * Returns `null` when no kitchen is active (chef has no kitchens, or the
 * picker hasn't resolved yet). Components should render a safe fallback
 * in that case.
 */
import { createContext, type ReactNode, useContext } from 'react'

const ActiveKitchenContext = createContext<string | null>(null)

interface ProviderProps {
  kitchenLocationId: string | null
  children: ReactNode
}

export function ActiveKitchenProvider({ kitchenLocationId, children }: ProviderProps) {
  return <ActiveKitchenContext.Provider value={kitchenLocationId}>{children}</ActiveKitchenContext.Provider>
}

export function useActiveKitchen(): string | null {
  return useContext(ActiveKitchenContext)
}
